import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../Button';
import { ALBUM_SUBTYPE, ALBUM_TYPE } from '../../../../constants/albums';
import FormGroup from '../../FormGroup';
import { getCelebratedPersonName } from '../../../../apps/pro/views/AlbumFolder/FreemiumEvents/SpecialtyAlbumGreetingModal/helpers';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    album_type: PropTypes.oneOf(Object.keys(ALBUM_TYPE)),
    album_subtype: PropTypes.oneOf(Object.keys(ALBUM_SUBTYPE)),
  }),
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    phone_number: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const NameForm = ({
  album,
  values,
  handleSubmit,
  handleChange,
  handleBlur,
  loading,
}) => {
  const isFreemiumEvent =
    album.album_type === ALBUM_TYPE.EVENT &&
    album.album_subtype !== ALBUM_SUBTYPE.WEDDINGS;

  return (
    <Fragment>
      <p className="mb-3 text-center px-md-6">
        Add your name so that{' '}
        {isFreemiumEvent
          ? getCelebratedPersonName(
              album.album_subtype,
              album.root_album_folder.event_settings,
              false,
              album?.root_album_folder?.account?.organization_name ??
                album?.root_album_folder?.account?.name,
            )
          : 'the owner'}{' '}
        knows which photos were added by you.
      </p>
      <form
        onSubmit={handleSubmit}
        className="w-100 px-0 px-md-6 d-flex flex-column align-items-center"
      >
        <FormGroup
          id="name"
          name="name"
          label=""
          placeholder="Name"
          labelType="expanded"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
          className="w-100 mb-0"
          autoFocus
        />
        <Button
          btnBlock
          type="submit"
          className="mt-2 mb-4"
          disabled={loading || !values.name}
        >
          {loading ? 'Saving...' : 'Confirm'}
        </Button>
      </form>
    </Fragment>
  );
};

NameForm.propTypes = propTypes;

export default NameForm;
